"use client";

import { markAuthStore, selectIsUserLoggedIn } from "stores/auth/authSlice";
import { useAppDispatch, useAppSelector } from "stores/hooks";
const LoginLinkButton = () => {
  const dispatch = useAppDispatch();
  const isLoggedIn = useAppSelector(selectIsUserLoggedIn);
  if (isLoggedIn) return null;
  const handleClick = () => {
    dispatch(markAuthStore({
      ui: {
        isLoginFlow: true,
        isSigningUpWithEmail: true,
        modalType: "LOGIN_WITH_EMAIL"
      }
    }));
  };
  return <p className='text-center text-[13px] leading-[1.5] text-brand-dark md:text-[22px]' data-sentry-component="LoginLinkButton" data-sentry-source-file="LoginLinkButton.tsx">
      Already have an account?{" "}
      <button type='button' onClick={handleClick} className='underline'>
        Log in
      </button>
    </p>;
};
export default LoginLinkButton;